export const iconClasses = 'h-6 w-6';
